<ng-template #ownersPopover>
    <div *ngFor="let owner of owners">{{ owner }}</div>
</ng-template>

<div *ngIf="!isAbandoned && owners" >
    <span *ngIf="owners.length > 1" [ngbPopover]="ownersPopover" popoverClass="ownersPopover" triggers="mouseenter:mouseleave" container="body" placement="bottom top">
        {{ owners.length }} employees
    </span>
    <span *ngIf="owners.length === 1">{{ owners[0] }}</span>
</div>
<div *ngIf="isAbandoned && owners.length === 1" class="color-iconDefault">
    <svg class="icon-16 fill-iconDefault-noHover">
        <use href="../App_Themes/CXone/icons/user-inactive.svg#user-inactive"></use>
    </svg>
    {{ owners[0] }}
</div>
